import { createWebHistory, createRouter } from 'vue-router';
import { reportError } from '@/services/errors';
import { reactive } from 'vue';

export const navigationState = reactive({ loading: false });

const Jobs = () => import('@/views/Jobs.vue');
const Map = () => import(/* webpackChunkName: "map" */ '@/views/Map.vue');
const Login = () => import('@/views/Login.vue');
const HomePage = () => import('@/views/HomePage.vue');
const Stats = () => import(/* webpackChunkName: "dashboard" */ '@/views/Stats.vue');
const Reports = () => import('@/views/Reports.vue');
const AdvancedStats = () => import('@/views/AdvancedStats.vue');
const Sites = () => import('@/views/Sites.vue');
const CurrentOuting = () => import('@/views/CurrentOuting.vue');
const CullView = () => import('@/views/CullView.vue');
const OrderSuccess = () => import('@/views/OrderConfirmation.vue');
const OrderFail = () => import('@/views/OrderFailure.vue');
const Bookings = () => import('@/views/Bookings.vue');
const CullsVsPlans = () => import('@/views/CullsVsPlans.vue');
const Reporting = () => import('@/views/Reporting.vue');
const TrackGroupMembers = () => import('@/views/TrackGroupMembers.vue');

const routes = [
  {
    path: '/map',
    name: 'Map',
    component: Map,
  },
  {
    path: '/liveonsite',
    name: 'TrackGroupMembers',
    component: TrackGroupMembers,
  },
  {
    path: '/advanced',
    name: 'Advanced',
    component: AdvancedStats,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/outings',
    name: 'Reports',
    component: Reports,
  },
  {
    path: '/dashboard',
    name: 'Statistics',
    component: Stats,
  },
  {
    path: '/sites',
    name: 'Sites',
    component: Sites,
  },
  {
    path: '/current-outing',
    name: 'CurrentOuting',
    component: CurrentOuting,
  },
  {
    path: '/culls',
    name: 'Culls',
    component: CullView,
  },
  {
    path: '/order-confirm',
    name: 'ConfirmOrder',
    component: OrderSuccess,
  },
  {
    path: '/order-fail',
    name: 'FailOrder',
    component: OrderFail,
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: Bookings,
  },
  {
    path: '/reporting',
    name: 'Reporting',
    component: Reporting,
  },
  {
    path: '/cullsvsplans',
    name: 'CullsVsPlans',
    component: CullsVsPlans,
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(() => {
  navigationState.loading = true;
});
router.afterEach(() => {
  navigationState.loading = false;
});
router.onError((error) => {
  navigationState.loading = false;
  reportError(error);
});

export default router;
